export { default } from "./tooltip";
